import React from "react";
import { Card } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const GaugeChartCard = ({ dashboardListings }) => {
  const navigate = useNavigate();
  // Data for the gauge chart
  const data = {
    labels: ["#FFCFB9", "#FFFFFF", "#FDBDA1", "Yellow/100"],
    datasets: [
      {
        data: [50, 25, 12.5, 12.5], // Divide the circle into four equal parts
        backgroundColor: ["#FFFFFF", "#FFCFB9", "#FDBDA1", "#FBDE9D"],
        borderColor: "#EB662B", // Same as card background to create gaps
        borderWidth: 4, // Smaller border width for thinner lines and gaps
        borderRadius: 10, // Border radius for rounded segments
        spacing: 5, // Creates gaps between segments
      },
    ],
  };

  // Options for the gauge chart
  const options = {
    cutout: "80%", // Make it look like a gauge by cutting out a part
    rotation: 270, // Rotate to start from the bottom
    circumference: 180, // Limit to half-circle
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      tooltip: {
        enabled: false, // Disable tooltips
      },
    },
  };

  return (
    <Card
      onClick={()=>navigate("/products")}
      className="dod-dash-main-page-gauge-card"
      style={{
        backgroundColor: "#EB662B",
        padding: "20px",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "none",
      }}
    >
      <div
        style={{
          width: "200px",
          height: "213px",
        }}
        className=" position-relative d-flex flex-column align-items-center justify-content-center"
      >
        <h1
          className="position-absolute"
          style={{ color: "#FFFFFF", marginBottom: "-40px" }}
        >
          {dashboardListings?.products?.totalProducts}
        </h1>
        <Doughnut
          data={data}
          options={options}
          style={{ maxWidth: "200px", height: "200px" }}
        />
      </div>
      <p className="m-0 p-0 text-white ob-pi-label">Total products</p>
      <p className="m-0 p-0 text-white ob-pi-note">
        Tap to manage or improve your products
      </p>
    </Card>
  );
};

export default GaugeChartCard;
